import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AppThunk, RootState} from "./store";
import Config from "../config";

interface GlobalLayoutState {
  selectedTabObject: string | null;
  selectedApp: string | null;
}

const initialState: GlobalLayoutState = {
  selectedTabObject: null,
  selectedApp: null
};

export const globalLayoutSlice = createSlice({
  name: "globalLayout",
  initialState,
  reducers: {
    storeSelectedTabObject: (state, action: PayloadAction<string | null>) => {
      state.selectedTabObject = action.payload;
    },
    storeSelectedApp: (state, action: PayloadAction<string | null>) => {
      state.selectedApp = action.payload;
    },
    purgeStore: (state) => {
      state.selectedTabObject = null;
      state.selectedApp = null;
    },
  },
});



export const { storeSelectedTabObject,
               storeSelectedApp,
               purgeStore } = globalLayoutSlice.actions;

export const setSelectedTabObject =
  (objectApiName: string | null): AppThunk => async(dispatch) => {

//      dispatch(purgeStore());
      await dispatch(storeSelectedTabObject(objectApiName));

  };

export const setSelectedApp =
  (appApiName: string | null): AppThunk => async(dispatch) => {

//      dispatch(purgeStore());
      await dispatch(storeSelectedApp(appApiName));

  };


export const getSelectedTabObject = (state: RootState) => {
  return state.globalLayoutStore.selectedTabObject;
}

export const getSelectedApp = (state: RootState) => {
  return state.globalLayoutStore.selectedApp;
}

export default globalLayoutSlice.reducer;
